/* eslint-disable no-param-reassign */
import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const api = axios.create({ baseURL: API_BASE_URL });
api.interceptors.request.use(async (config) => {
  try {
    const token = JSON.parse((await localStorage.getItem('@legalhub:token')) || '');

    if (token && config?.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    //...
  }
  return config;
});
export default api;
